import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  groupCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'authService',
    'groupModel',
    'userModel',
    'roleModel',
    'folderModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      authService,
      Group,
      User,
      Role,
      Folder
    ) {
      'use strict';

      var _folderRoles = [];

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          var error = {
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status === 400 && err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE GROUP'),
        };
      }

      function sortColumns() {
        return [
          {
            column: 'name',
            title: 'NAME',
            type: 'text',
            sortOrder: 'asc',
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();

        deferred.resolve([]);

        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();

        var filters = null;
        deferred.resolve(filters);

        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();

        var url = 'groups/withUsers';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Group(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function getFoldersRoles(f, group) {
        if (Array.isArray(f.permissions) && f.permissions.length > 0) {
          var roles = f.permissions.map(function (p) {
            return {
              IdGroup: group.id,
              IdFolder: f.id,
              IdRole: p,
            };
          });

          roles.forEach(function (r) {
            if (
              !_folderRoles.some(function (f) {
                return (
                  f.IdGroup === r.IdGroup &&
                  f.IdFolder === r.IdFolder &&
                  f.IdRole === r.IdRole
                );
              })
            ) {
              _folderRoles.push(r);
            }
          });
        }

        if (Array.isArray(f.children) && f.children.length > 0) {
          for (var i = 0, len = f.children.length; i < len; i++) {
            getFoldersRoles(f.children[i], group);
          }
        }
      }

      function save(group) {
        var deferred = $q.defer();

        _folderRoles = [];
        group.users = [];

        var users = group.allUsers.filter(function (c) {
          return c.selected;
        });
        users.forEach(function (u) {
          group.users.push({
            IdGroup: group.id,
            IdUser: u.id,
          });
        });

        if (Array.isArray(group.folders)) {
          for (var i = 0, len = group.folders.length; i < len; i++) {
            getFoldersRoles(group.folders[i], group);
          }
        }

        var data = {
          Id: group.id,
          IdCompany: authService.getLoggedCompany().IdCompany,
          Name: group.name,
          GroupsUsers: group.users,
          GroupsFoldersRoles: group.folders ? _folderRoles : null,
        };

        if (group.id === 0) {
          $http
            .post(webApiSettings.apiServiceBaseUri + 'groups', data, {
              ignoreLoadingBar: true,
            })
            .then(() => {
              deferred.resolve();
            })
            .catch((err) => {
              deferred.reject(handleError(err.data, err.status));
            });
        } else {
          $http
            .put(webApiSettings.apiServiceBaseUri + 'groups', data, {
              ignoreLoadingBar: true,
            })
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        }

        return deferred.promise;
      }

      function selectUsers(group, users) {
        group.users.forEach(function (c) {
          var us = users.filter(function (u) {
            return u.id === c.IdUser;
          });

          if (us.length > 0) {
            us[0].selected = true;
          }
        });
        group.allUsers = users;
      }

      function load(id) {
        var deferred = $q.defer();

        var group = new Group();
        var users = null;
        var loaded = false;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'users/byCompany', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              users = [];

              data.forEach(function (d) {
                var user = new User(d);
                users.push(user);
              });

              if (id && group.id !== 0 && !loaded) {
                selectUsers(group, users);
                loaded = true;
                deferred.resolve(group);
              } else if (!id && !loaded) {
                group.allUsers = users;
                loaded = true;
                deferred.resolve(group);
              }
            },
            function (err) {
              deferred.reject({
                error: err.data,
                status: err.status,
              });
            }
          );

        if (id) {
          $http
            .get(webApiSettings.apiServiceBaseUri + 'groups/withUsers/' + id, {
              ignoreLoadingBar: true,
            })
            .then(
              function (result) {
                var data = result.data;
                data = resolveReferences(data);
                group = new Group(data);

                if (users !== null && !loaded) {
                  selectUsers(group, users);
                  loaded = true;
                  deferred.resolve(group);
                }
              },
              function (err) {
                deferred.reject({
                  error: err.data,
                  status: err.status,
                });
              }
            );
        }

        return deferred.promise;
      }

      function recursiveCreateTree(items, parent) {
        if (
          parent !== null &&
          parent !== undefined &&
          items.some(function (c) {
            return c.idParent === parent.id;
          })
        ) {
          parent.children = [];

          for (var i = 0, len = items.length; i < len; i++) {
            var c = items[i];

            c.treeItemType = c.idParent === null ? 0 : 1;
            if (c.idParent === parent.id) {
              var childs = items.splice(i, 1);
              len--;
              i--;
              parent.children.push(childs[0]);
            }
          }
        } else {
          return;
        }

        //Chama o create tree para cada um dos filhos
        for (var j = 0, length = parent.children.length; j < length; j++) {
          recursiveCreateTree(items, parent.children[j]);
        }
      }

      function checkFoldersPermissions(folders, permissions) {
        if (!Array.isArray(folders) || folders.length <= 0) {
          return;
        }

        for (var q = 0, qlen = folders.length; q < qlen; q++) {
          var folder = folders[q];

          folder.permissions = permissions[folder.id];

          checkFoldersPermissions(folder.children, permissions);
        }
      }

      function loadPermissions(currentItem) {
        var deferred = $q.defer();

        var group = currentItem;
        var folders = null;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'roles', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              var roles = [];
              data = resolveReferences(data);

              for (var i = 0; i < data.length; i++) {
                roles.push(new Role(data[i]));
              }

              group.roles = roles;

              if (
                currentItem.id &&
                group.folders !== null &&
                group.permissions
              ) {
                checkFoldersPermissions(group.folders, group.permissions);
                deferred.resolve(true);
              } else if (group.folders !== null) {
                deferred.resolve(true);
              }
            },
            function (err) {
              deferred.reject({
                error: err.data,
                status: err.status,
              });
            }
          );

        $http
          .get(webApiSettings.apiServiceBaseUri + 'folders/basic', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              folders = [];
              data = resolveReferences(data);
              for (var i = 0; i < data.length; i++) {
                folders.push(new Folder(data[i]));
              }

              var repositories = folders.filter(function (f) {
                return f.idParent === undefined || f.idParent === null;
              });

              for (i = 0; i < repositories.length; i++) {
                var parent = repositories[i];

                recursiveCreateTree(folders, parent);
              }

              group.folders = repositories;

              if (group.id && group.roles !== null && group.permissions) {
                checkFoldersPermissions(group.folders, group.permissions);
                deferred.resolve(true);
              } else if (group.roles !== null) {
                deferred.resolve(true);
              }
            },
            function (err) {
              deferred.reject({
                error: err.data,
                status: err.status,
              });
            }
          );

        if (group.id) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri +
                'groups/folders/roles/' +
                group.id,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function (result) {
                var data = result.data;
                group.permissions = data;

                if (group.roles !== null && group.folders !== null) {
                  checkFoldersPermissions(group.folders, group.permissions);
                  deferred.resolve(true);
                }
              },
              function (err) {
                deferred.reject({
                  error: err.data,
                  status: err.status,
                });
              }
            );
        }

        return deferred.promise;
      }

      function loadData(tab, currentItem) {
        if (tab === 'permissoes') return loadPermissions(currentItem);
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'groups/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http.post(webApiSettings.apiServiceBaseUri + url, ids).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var groupCrudFactory = {};

          groupCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.loadData = logWrapper(
            loadData,
            runtimeConstant.isDebugServicesInternals
          );
          groupCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );

          return groupCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
